import { Selector } from "@ngxs/store";
import { SelectedSubtreeVariablesState, SelectedSubtreeVariablesStateModel } from "./selected-subtree-variables.state";

export class SelectedSubtreeVariablesGetterState {
  @Selector([SelectedSubtreeVariablesState])
  static getSelectedSubTreeVariables(state: SelectedSubtreeVariablesStateModel) {
    return state.tags;
  }

  @Selector([SelectedSubtreeVariablesState])
  static getSelectedSubTreeVariableValues(state: SelectedSubtreeVariablesStateModel) {
    return state.tags;
  }
}